<div class="menu-selector-wrapper">
    <div class="back-button clickable" *ngIf="!isLobbyHome() && !isSocial() && !forGameTypes()" (click)="navigateBack()">
        <div class="arrow-back">
            <ion-icon name="chevron-back"></ion-icon>
        </div>
        <div class="label">{{ getBackButtonText() }}</div>
    </div>
    <div class="menu-selector" [ngClass]="{ 'not-lobby-home': !isLobbyHome() && !isSocial() && !forGameTypes() }">
        @for (selector of selectors(); track $index) {
            <div class="label-container clickable" (click)="onSelectMenu(selector)">
                <div class="label" [ngClass]="{'game-types': forGameTypes(), 'lobby-menu': !forGameTypes(), 'activated': activeMenu() === selector || activeSocialMenu() === selector || activeGameTypesMenu() === selector}">
                    @switch (selector) {
                        @case('RNG') { {{ 'RING' }} }
                        @case ('sweeps') { {{ 'SWEEPSTAKES' }} }
                        @default { {{ selector.toString().toUpperCase() }} }
                    }
                </div>
            </div>
        }
    </div>
</div>
